class ResponsiveHeroBackgroundHandler {
    respBgAttr = 'data-baz-responsive-bg-image';
    respImgDataAttrLoadMap = {
        'data-src': 'src',
        'data-srcset': 'srcset',
        'data-sizes': 'sizes'
    };

    // map img el to current src str
    imgSrcMap = new Map();

    constructor() {
        this.initialize();
    }

    initialize() {
        let containerEls = document
            .querySelectorAll(`[${this.respBgAttr}]`);

        Array.from(containerEls).forEach(containerEl => {
            let imgEl = containerEl.querySelector('img');
            if(!imgEl) {
                return;
            }

            this.initializeResponsiveImage(imgEl);

            // when srcset change is triggered via media query a load event will trigger an update
            imgEl.addEventListener('load', () => {
                this.updateContainerBackground(containerEl, imgEl);
            });

            if (imgEl.complete) {
                this.updateContainerBackground(containerEl, imgEl);
            }
        });
    }

    updateContainerBackground(containerEl, imgEl) {
        let oldSrc = '';
        let newSrc = typeof imgEl.currentSrc !== 'undefined'
            ? imgEl.currentSrc
            : imgEl.src;

        if(this.imgSrcMap.has(imgEl)) {
            oldSrc = this.imgSrcMap.get(imgEl);
        }

        if(newSrc != oldSrc) {
            containerEl.setAttribute('style', `background-image: url(${newSrc});`);
            this.imgSrcMap.set(imgEl, newSrc);
        }
    }

    // modify responsive site header img tag (data-src => src & data-srcset => srcset, etc.)
    // in order to actually load img data.
    //
    // this is done in order to prevent unnecessary data load when the noscript version
    // of the header is used (otherwise, though hidden, the responsive js-dependant
    // version which uses a separate img-tag, will trigger a double img data load)

    initializeResponsiveImage(imgEl) {
        Object.keys(this.respImgDataAttrLoadMap).forEach(dataAttr => {
            imgEl.setAttribute(
                this.respImgDataAttrLoadMap[dataAttr],
                imgEl.getAttribute(dataAttr)
            );

            imgEl.removeAttribute(dataAttr);
        });
    }
}

export default ResponsiveHeroBackgroundHandler;
